import * as React from 'react';
import { Typography } from '@mui/material';

export const CustomTypography = ({ text, variant = 'h6', sx = {}, ...otherProps }) => {
    return (
        <Typography
            variant={variant}
            sx={{
                fontSize: '16px',
                fontWeight: '400',
                ...sx,
            }}
            {...otherProps}
        >
            {text}
        </Typography>
    );
};



